import { enc, SHA256, AES, HmacSHA256 } from "crypto-js";
import { compressToBase64, decompressFromBase64 } from "lz-string";

const secretKeyText = "my-32-character-ultra-secure-and-ultra-long-secret";
const secret = enc.Hex.stringify(SHA256(secretKeyText));

const base64Encode = (rawString) => {
  const wordArray = enc.Utf8.parse(rawString);
  return enc.Base64.stringify(wordArray).replace("=", "").replace("=", "");
};
const base64Decode = (base64String) => {
  const wordArray = enc.Base64.parse(base64String);
  return enc.Utf8.stringify(wordArray);
};

export function encryptAES(data) {
  //console.log(data, "ljkh");
  return AES.encrypt(data, secretKeyText).toString();
}
export function encryptAESEncode(data) {
  return AES.encrypt(JSON.stringify(data), secretKeyText).toString();
}

export function decryptAES(encrypted) {
  const bytes = AES.decrypt(encrypted, secretKeyText);
  return bytes.toString(enc.Utf8);
}
export function compress(data) {
  return compressToBase64(JSON.stringify(data));
}
export function decompress(data) {
  return JSON.parse(decompressFromBase64(data));
}
export function jwtSign(payload = {}) {
  payload.createdAt = new Date().toISOString();
  const base64Payload = base64Encode(JSON.stringify(payload));
  const signature = HmacSHA256(base64Payload, secret);
  const base64Signature = base64Encode(signature);
  return base64Encode(`${base64Signature}:${base64Payload}`);
}
export function jwtVerify(token) {
  const decoded = base64Decode(token);
  const [sig, payload] = decoded.split(":").filter((d) => d.length > 0);
  const validSig = base64Encode(HmacSHA256(payload, secret));
  if (sig === validSig) {
    return { auth: true, payload: JSON.parse(base64Decode(payload)) };
  }
  return { auth: false, payload: null };
}
